import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/git/nexaid-website/src/app/technology-infrastructure/components/IntegrationArchitecture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/git/nexaid-website/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/git/nexaid-website/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/git/nexaid-website/src/components/ui/AppIcon.tsx");
